/*
*   File : portfolio-summary.js
*   Author : https://evoqins.com
*   Description : Portfolio summary page
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

//Style
import style from "../../Styles/Component/portfolio.module.scss";

//Custom components
import { EmptyScreen, Loader } from '../../Component/Others';
import { AlphaBasketCard } from '../../Component/Cards';
import { APIService } from '../../Service';
import { _scrollToTop } from '../../Helper';

// Assets
import EmptyPortfolio from '../../Assets/Images/EmptyScreen/empty-portfolio.webp';
const PortfolioSummary = () => {


    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const scrollRef = useRef(null);
    const navigate = useNavigate();

    // const [selected, setSelected] = useState([OPTIONS[0]]);
    const [portfolioList, setPortFolioList] = useState({});
    const [toggleFilter, setToggleFilter] = useState(false);
    // const [selectedFilter, setSelectedFilter] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        // API Call
        _getPortfolioData();
        // Scroll the page to top
        _scrollToTop();
    }, []);

    useEffect(() => {
        if (toggleFilter === true) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [toggleFilter]);


    // handle navigate to portfolio detail page
    const _handleNavigateToDetail = (product) => {
        navigate("detail", {
            state: {
                product
            }
        });
    };

    // handle navigate to explore page
    const _handleStartInvesting = () => {
        navigate("/explore");
    };


    // ===================================== //
    // ============ API CALLS ============== //

    // Get portfolio list
    const _getPortfolioData = async () => {

        let url = "portfolio/list";
        let data = {
            "page_num": 1,
            "user_id": USER_DATA.unique_identifier,
            "portfolio_type": "Basket",
            "tenant_id": USER_DATA.referral_master_info.creator_id,
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            setPortFolioList(response.data);
        } else {
            setPortFolioList("");
        }
        setDataLoading(false);
    };

    return (
        <>
            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-200px-top" />
                    :
                    <>

                        <section className={`${style.e_portfolio_summary_wrapper} e-bg-white border-radius-16 pb-5 margin-26px-bottom min-h-100vh`}>
                            {
                                portfolioList && portfolioList.active_portfolio.length !== 0 ?
                                    <>
                                        <div className={`${style.e_top_section} border-radius-16 p-3 p--sm-4`}>
                                            <h4 className='e-font-18-res e-primary-font-clash-display e-text-white e-font-20 e-font-weight-500 line-height-24px'>
                                                Portfolio
                                            </h4>

                                            <div ref={scrollRef} className='row gap-sm-2 flex-wrap g-3'>
                                                {/* Current Value and Invested Amount */}
                                                <div className="col-12 col-sm-auto">
                                                    <div className={`${style.e_amount_wrapper}  d-flex justify-content-between  gap-0px-res gap-64px p-3 border-radius-8`}>
                                                        <div className='d-flex flex-column gap-1'>
                                                            <p className='mb-0 e-text-magnolia e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                                Current Value
                                                            </p>
                                                            <p className='e-font-16-res  mb-0 e-text-white e-alt-font-lato e-font-18 e-font-weight-600 line-height-24px'>
                                                                ₹{Number(portfolioList.total_current_value).toLocaleString("en-IN")}
                                                            </p>
                                                        </div>
                                                        <div className='d-flex flex-column gap-1'>
                                                            <p className='mb-0 e-text-magnolia e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                                Invested Amount
                                                            </p>
                                                            <p className='e-font-16-res mb-0 e-text-white e-alt-font-lato e-font-18 e-font-weight-600 line-height-24px'>
                                                                ₹{Number(portfolioList.total_current_investment).toLocaleString("en-IN")}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Total Returns */}
                                                <div className={`col-6 col-sm-auto`}>
                                                    <div className='e-bg-dutch-white d-flex flex-column gap-1 p-3 border-radius-8'>
                                                        <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                            {portfolioList.return_total_data.label}
                                                        </p>
                                                        <p className={`${portfolioList.return_total_data.value < 0 ? "e-text-red" : "e-text-islamic-green"} e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-24px`}>
                                                            {portfolioList.return_total_data.value_str}
                                                            {
                                                                portfolioList.return_total_data.label === "Total Returns" &&
                                                                <span className={`${portfolioList.total_returns_per < 0 ? "e-text-red" : "e-text-islamic-green"} e-font-12 line-height-20px`}>
                                                                    (₹{Number(portfolioList.total_returns).toLocaleString("en-IN")})
                                                                </span>
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Investments */}
                                        <div className='p-3'>
                                            <div className='row'>
                                                <div className='col-12 col-sm-10 col-md-8 col-lg-6'>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <h6 className='mb-0 e-primary-font-clash-display e-text-black e-font-16 e-font-weight-500 line-height-24px'>
                                                            Investments
                                                        </h6>
                                                    </div>
                                                    <div className='pt-3'>
                                                        {/* Alpha baskets */}
                                                        <div className='pb-3'>
                                                            {portfolioList.active_portfolio.map((product, key) => (
                                                                <div key={key} className='mb-3' >
                                                                    <AlphaBasketCard product={product}
                                                                        category={product.strategy_type}
                                                                        type={3}
                                                                        handleClick={() => _handleNavigateToDetail(product)} />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <div className="p-4">
                                        <h4 className='e-font-18-res e-primary-font-clash-display e-text-primary-color e-font-20 e-font-weight-500 line-height-24px'>
                                            Portfolio
                                        </h4>
                                        <EmptyScreen
                                            type={1}
                                            emptyScreenImage={EmptyPortfolio}
                                            description="You haven't invested yet. Invest now and start growing your wealth."
                                            btnLabel="Start Investing"
                                            onClick={_handleStartInvesting} />
                                    </div>
                            }
                        </section>

                    </>

            }
        </>
    )
}

export default PortfolioSummary;
